import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  AdminControlEmployeeTarget,
  AdminControlMigrationResult,
  AdminToEmployeeControlledService,
} from 'src/app/Services/admin-to-employee-controlled.service';

export interface AdminControlToGeneralDialogData {
  employees: AdminControlEmployeeTarget[];
}

type DialogStep = 'confirm' | 'processing' | 'result';

@Component({
  selector: 'app-admin-control-to-general-dialog',
  templateUrl: './admin-control-to-general-dialog.component.html',
  styleUrls: ['./admin-control-to-general-dialog.component.css'],
  standalone: false,
})
export class AdminControlToGeneralDialogComponent {
  step: DialogStep = 'confirm';
  results: AdminControlMigrationResult[] = [];
  errorMessage = '';

  constructor(
    public dialogRef: MatDialogRef<AdminControlToGeneralDialogComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) public data: AdminControlToGeneralDialogData,
    private migrationService: AdminToEmployeeControlledService
  ) {}

  get employeeCount(): number {
    return this.data.employees.length;
  }

  get successfulResults(): AdminControlMigrationResult[] {
    return this.results.filter((result) => result.success);
  }

  get failedResults(): AdminControlMigrationResult[] {
    return this.results.filter((result) => !result.success);
  }

  getEmployeeInitials(name: string): string {
    const trimmed = String(name || '').trim();
    if (!trimmed) {
      return '?';
    }
    const parts = trimmed.split(/\s+/).filter(Boolean);
    if (parts.length >= 2) {
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
    return trimmed.slice(0, 2).toUpperCase();
  }

  getEmployeeTooltip(employee: AdminControlEmployeeTarget): string {
    return employee.email?.trim() || employee.name;
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.step = 'processing';
    this.errorMessage = '';

    this.migrationService.migrateEmployees(this.data.employees).subscribe({
      next: (results) => {
        this.results = results;
        this.step = 'result';
      },
      error: (error) => {
        this.step = 'confirm';
        this.errorMessage =
          error?.error?.message ||
          error?.message ||
          'Could not update tracking settings. Please try again.';
      },
    });
  }

  onDone(): void {
    this.dialogRef.close(this.successfulResults.length > 0);
  }
}
